"use client";

import { useEffect, useState } from "react";
import { formatMultipleTimezones } from "@/lib/timezone";

type CurrentTimeProps = {
  timezoneIds: string[];
  timezoneLabels: string[];
};

export default function CurrentTime({ timezoneIds, timezoneLabels }: CurrentTimeProps) {
  const [now, setNow] = useState<Date | null>(null);

  useEffect(() => {
    setNow(new Date());
    const timer = window.setInterval(() => setNow(new Date()), 60_000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <span suppressHydrationWarning>
      {formatMultipleTimezones(timezoneIds, timezoneLabels, now ?? new Date())}
    </span>
  );
}
